import Image from "next/image";
import SMixedGoalsLabel from "src/Resources/Images/sustainability/sustainability-mixed-goals.png";
import SFocusLabel from "src/Resources/Images/sustainability/sustainability-focus.png";
import SImpactLabel from "src/Resources/Images/sustainability/sustainability-impact.png";
import SImproversLabel from "src/Resources/Images/sustainability/sustainability-improvers.png";


export default function SustainabilityLabel({ sustainabilityReport, profile }) {

    if (profile?.domicile !== "GBR") {
        return <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm padding-bottom-0">
            <span className="card-title margin-bottom-20" data-testid="sustainabilityLabel">
                Sustainability Label
            </span>
            <p>
                <span>This product is based overseas and is not subject to UK sustainable investment labelling and disclosure requirements. </span>
                <a href="https://www.fca.org.uk/consumers/sustainable-investment-labels-greenwashing" target="_blank">Learn more about SDR.</a>
            </p>
            <hr />
        </div>
    </div>
    }

    if (!sustainabilityReport?.SDR?.SDRCurrent?.SDRLabel || !sustainabilityReport?.SDR?.SDRCurrent?.ProportionOfAssetsInvestedInSDRLabel) {
        return null;
    }

    const sdrCurrent = sustainabilityReport.SDR.SDRCurrent;
    const sdrFundLabel = sdrCurrent.ProportionOfAssetsInvestedInSDRLabel;
    const focusLabelMin = sdrFundLabel.SustainabilityFocusLabelMin;
    const focusLabelMax = sdrFundLabel.SustainabilityFocusLabelMax;
    const imporversLabelMin = sdrFundLabel.SustainabilityImproversLabelMin;
    const imporversLabelMax = sdrFundLabel.SustainabilityImproversLabelMax;
    const impactLabelMin = sdrFundLabel.SustainabilityImpactLabelMin;
    const impactLabelMax = sdrFundLabel.SustainabilityImpactLabelMax;


    let image = null;
    let alt = null;
    switch (sustainabilityReport.SDR.SDRCurrent.SDRLabel) {
        case 'Sustainability Mixed Goals':
            image = SMixedGoalsLabel;
            alt = "Mixed goal funds both directly and indirectly pursue or improve positive environmental or social outcomes or both in the same manner as the Impact, Focus and Improver labels.";
            break;
        case 'Sustainability Focus':
            image = SFocusLabel;
            alt = "Focus funds indirectly pursue positive environmental or social outcomes or both by investing in assets that meet a robust, evidence-based standard of sustainability."
            break;
        case 'Sustainability Impact':
            image = SImpactLabel;
            alt = "Impact funds directly pursue positive environmental or social outcomes or both through both the fund manager's investment activities and the sustainability characteristics of the assets."
            break;
        case 'Sustainability Improvers':
            image = SImproversLabel;
            alt = "Improver funds indirectly improve positive environmental or social outcomes or both by investing in assets that have the potential to meet a robust, evidence-based standard of sustainability."
            break;
        default: 
            null;
    }


    return <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm padding-bottom-0">
            <span className="card-title margin-bottom-20" data-testid="sustainabilityLabel">
                Sustainability Label
            </span>

            {sustainabilityReport.SDR &&
                <span aria-label={alt} data-balloon-length="large" data-balloon-pos="up" className="inline-block" >
                    <Image
                        src={image}
                        style={{ maxWidth: "200px" }}
                    />
                </span>
            }

            {sustainabilityReport.SDR && sustainabilityReport.SDR.SDRCurrent.SDRLabel === 'Sustainability Mixed Goals' && 
            <table className="data-table data-table--small data-table--scroll margin-bottom-20 margin-top-0">
                <tbody>
                    {focusLabelMin && focusLabelMax &&
                    <tr>
                        <td scope="row" width="70%">
                            <span className="font-weight-bold">Focus</span>
                            <a aria-label="Invests in assets that are environmentally and/or socially sustainable." data-balloon-length="large" data-balloon-pos="up">
                                <i className="fas fa-question-circle tooltipped margin-left-10" />
                            </a>
                        </td>
                        <td>{focusLabelMin} - {focusLabelMax}%</td> 
                    </tr> }
                    {imporversLabelMin && imporversLabelMax &&
                    <tr> 
                        <td scope="row" width="70%">
                            <span className="font-weight-bold">Improvers</span>
                            <a aria-label="Invests in assets with the potential to improve environmental and/or social sustainability." data-balloon-length="large" data-balloon-pos="up">
                                <i className="fas fa-question-circle tooltipped margin-left-10" />
                            </a>
                        </td> 
                        <td>{imporversLabelMin} - {imporversLabelMax}%</td>
                    </tr> }
                    {impactLabelMin && impactLabelMax &&
                    <tr>
                        <td scope="row" width="70%">
                            <span className="font-weight-bold">Impact</span>
                            <a aria-label="Invests in assets that aim to have a positive environmental and/or social impact." data-balloon-length="large" data-balloon-pos="up">
                                <i className="fas fa-question-circle tooltipped margin-left-10" />
                            </a>
                        </td>
                        <td>{impactLabelMin} - {impactLabelMax}%</td>
                    </tr> }
                </tbody>
            </table>}
            <p>
                <span>This product uses the above Sustainability Disclosure Requirements (SDR) label. </span>
                <a href="https://www.fca.org.uk/consumers/sustainable-investment-labels-greenwashing" target="_blank">Learn more about SDR.</a>
            </p>
            <hr />
        </div>
    </div>
}
